var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "profile_modal",
      attrs: {
        size: "xl",
        bodyClass: "p-0",
        "no-close-on-backdrop": true,
        "hide-header": true,
        dialogClass: _vm.dialog_class_draw,
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "outline-danger" },
                  on: {
                    click: function ($event) {
                      return close()
                    },
                  },
                },
                [_vm._v("\n                Close Modal\n            ")]
              ),
            ]
          },
        },
        {
          key: "modal-footer",
          fn: function ({ close }) {
            return [
              _c("div", { staticClass: "modal-footer w-100" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-outline-danger waves-effect waves-themed mr-5",
                    attrs: { type: "button" },
                    on: { click: _vm.remove_item },
                  },
                  [_vm._v("\n                    Видалити\n                ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-secondary waves-effect waves-themed ml-5",
                    attrs: { type: "button" },
                    on: { click: _vm.close_modal },
                  },
                  [_vm._v("\n                    Закрити\n                ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success waves-effect waves-themed",
                    attrs: { type: "button" },
                    on: { click: _vm.save_doc },
                  },
                  [_vm._v("\n                    Зберегти\n                ")]
                ),
              ]),
            ]
          },
        },
      ]),
      model: {
        value: _vm.is_show_modal,
        callback: function ($$v) {
          _vm.is_show_modal = $$v
        },
        expression: "is_show_modal",
      },
    },
    [
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "panel mb-0 border-bottom-0 shadow-none",
          attrs: { id: "panel_users_list" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0",
            },
            [
              _c("h2", [
                _c("span", { staticClass: "fw-300" }, [
                  _vm._v("ID:" + _vm._s(this.doc.id)),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "panel-toolbar pr-3 pb-2 align-self-end" },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed",
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_c("i", { staticClass: "fal fa-times" })]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          !_vm.is_load
            ? _c("div", { staticClass: "p-4" }, [
                _c("div", { staticClass: "form-group mt-2" }, [
                  _c(
                    "label",
                    {
                      staticClass: "form-label",
                      attrs: { for: "advanced_name" },
                    },
                    [
                      _vm._v(
                        "\n                        ID\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group flex-nowrap" }, [
                    _c("div", { staticClass: "input-group-prepend" }, [
                      _c("span", { staticClass: "input-group-text" }, [
                        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.doc.id,
                          expression: "doc.id",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        id: "advanced_name",
                        disabled: "",
                        type: "text",
                      },
                      domProps: { value: _vm.doc.id },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.doc, "id", $event.target.value)
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group mt-2" }, [
                  _c(
                    "label",
                    {
                      staticClass: "form-label",
                      attrs: { for: "advanced_name" },
                    },
                    [
                      _vm._v(
                        "\n                        Email\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group flex-nowrap" }, [
                    _c("div", { staticClass: "input-group-prepend" }, [
                      _c("span", { staticClass: "input-group-text" }, [
                        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.doc.source,
                          expression: "doc.source",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { id: "advanced_name", type: "text" },
                      domProps: { value: _vm.doc.source },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.doc, "source", $event.target.value)
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group mt-2" }, [
                  _c(
                    "label",
                    {
                      staticClass: "form-label",
                      attrs: { for: "advanced_name" },
                    },
                    [
                      _vm._v(
                        "\n                        Пересилати на:\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group flex-nowrap" }, [
                    _c("div", { staticClass: "input-group-prepend" }, [
                      _c("span", { staticClass: "input-group-text" }, [
                        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.doc.destination,
                          expression: "doc.destination",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { id: "advanced_name", type: "text" },
                      domProps: { value: _vm.doc.destination },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.doc, "destination", $event.target.value)
                        },
                      },
                    }),
                  ]),
                ]),
              ])
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }